import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PrinterOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { App, Button, Card, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ExpenseBalanceFilters from "./component/ExpenseBalanceFilters";
import ExpenseBalanceTable from "./component/ExpenseBalanceTable";
import ExpenseBalancePrintView from "./component/ExpenseBalancePrintView";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const ExpenseBalanceReport = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const { message } = App.useApp();
    const { list } = useSelector((state) => state.expenseBalance);

    const reportRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: reportRef,
        documentTitle: "Expense Balance Report",
        removeAfterPrint: true,
    });

    const handleNavigateToReports = () => {
        navigate("/reports");
    };

    return (
        <div className="p-4">
            <App>
                <Card
                    className="shadow-md rounded-xl mb-4"
                    title={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Button
                                type="text"
                                icon={<ArrowLeftOutlined />}
                                onClick={handleNavigateToReports}
                                style={{ marginRight: 8 }}
                            />
                            <Title level={4} style={{ margin: 0 }} className="reportBigTitle" >Expense Balance Report</Title>
                        </div>
                    }
                    extra={
                        list.length > 0 && (
                            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                                { !screens.xs && "Print" }
                            </Button>
                        )
                    }
                    styles={{
                        header: { borderBottom: "none", padding: "12px 16px" },
                        body: { padding: 0 },
                    }}
                >
                    <ExpenseBalanceFilters messageApi={message} />
                </Card>

                <Card className="shadow-md rounded-xl">
                    <ExpenseBalanceTable />
                </Card>
            </App>

            <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
                <ExpenseBalancePrintView ref={reportRef} />
            </div>
        </div>
    );
};

export default ExpenseBalanceReport;